import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'

import Footer from 'components/Footer'

export const Layout = props => {
  const { children, message, logo } = props

  const isFooter = !isEmpty(logo) || !isEmpty(message)

  return (
    <div className="layout">
      <main className="layout__main-content">{children}</main>
      {isFooter && <Footer logo={logo} message={message} />}
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.string,
  message: PropTypes.string,
}

Layout.defaultProps = {
  isFooter: false,
}

export default Layout
